import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { PercentPipe as NgPercentPipe } from '@angular/common'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'
import { merge } from 'lodash';

@Pipe({ name: 'percent' })
export class PercentPipe implements PipeTransform {
  private pipe

  constructor(@Inject(LOCALE_ID) locale: string) {
    this.pipe = new NgPercentPipe(locale)
  }

  transform(value: number, options = {}): string {
    let decimalPlaces: number

    if (isNaN(value)) {
      throw invalidPipeArgumentError('percent', value)
    }

    if (value == null) {
      return 'n/a'
    }

    if (!isNaN(options['decimal_places'])) {
      decimalPlaces = options['decimal_places']
    } else {
      decimalPlaces = 2
    }

    const opts = merge({
      digits: `1.${decimalPlaces}-${decimalPlaces}`
    }, options)

    return this.pipe.transform(value, opts['digits'])
  }
}
